export enum VenueRuleType {
    ShortSelling = 'SHORT_SELLING',
}

export type VenueRuleValues = {
    maximumCapacity?: number | null,
    minimumPartySize?: number | null,
    [key: string]: number | null | undefined,
}

export class VenueRule {
    constructor(
        public id: string,
        public type: VenueRuleType,
        public daysOfWeek: number[],
        public values: VenueRuleValues
    ) { }

    get appliesEveryDay(): boolean {
        return this.daysOfWeek.length === 7
    }
}
